export enum ApplicationType {
    MOBILE_APPLICATION = "MOBILE_APPLICATION",
    WEBSITE = "WEBSITE"
}

export enum InspectionAuthority {
    BW = "BW",
    BY = "BY",
    BE = "BE",
    BB = "BB",
    HB = "HB",
    HH = "HH",
    HE = "HE",
    MV = "MV",
    NI = "NI",
    NW = "NW",
    RP = "RP",
    SL = "SL",
    SN = "SN",
    ST = "ST",
    SH = "SH",
    TH = "TH",
    BUND = "BUND"
}


export enum BooleanResult {
    EMPTY = "EMPTY",
    NOT_CHECKED = "NOT_CHECKED",
    YES = "YES",
    NO = "NO"
}

export enum CheckResult {
    EMPTY = "EMPTY",
    NOT_CHECKED = "NOT_CHECKED",
    PASSED = "PASSED",
    ESSENTIALLY_PASSED = "ESSENTIALLY_PASSED",
    FAILED = "FAILED",
    NOT_APPLICABLE = "NOT_APPLICABLE"
}

export enum ValidationResult {
    OK = "OK",
    WARNING = "WARNING"
}

export enum AdditionalCriterionResultType {
    CHECK_RESULT = "CHECK_RESULT",
    BOOLEAN_RESULT = "BOOLEAN_RESULT"
}

export enum DocumentType {
    PDF = "PDF",
    XLSX = "XLSX",
    DOCX = "DOCX",
    PPTX = "PPTX"
}

export enum ValidationFailedErrorResponseDTO {
    VALIDATION_ERROR = "VALIDATION_ERROR"
}

export enum StringMessageErrorResponseDTO {
    STRING_MESSAGE = "STRING_MESSAGE"
}

export enum ErrorCode {
    ARTIFACT_NAME_ALREADY_USED = "ARTIFACT_NAME_ALREADY_USED",
    ILLEGAL_ARGUMENT = "ILLEGAL_ARGUMENT",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    INVALID_CATALOG_ID = "INVALID_CATALOG_ID",
    INVALID_CONTENT_TYPE = "INVALID_CONTENT_TYPE",
    INVALID_IMPORT_FILE = "INVALID_IMPORT_FILE",
    MANDATORY_FIELD_VIOLATION = "MANDATORY_FIELD_VIOLATION",
    OBJECT_NOT_FOUND = "OBJECT_NOT_FOUND",
    UNAUTHORIZED = "UNAUTHORIZED",
    FORBIDDEN = "FORBIDDEN",
    FUTURE_DATE = "FUTURE_DATE",
    INCOMPATIBLE_APPLICATION_AND_SURVEY_TYPES = "INCOMPATIBLE_APPLICATION_AND_SURVEY_TYPES",
    WRONG_RECHECK_DATE = "WRONG_RECHECK_DATE",
    WRONG_DURATION_HOURS = "WRONG_DURATION_HOURS",
    NUMBER_FORMAT = "NUMBER_FORMAT",
    INVALID_RECHECK_ID = "INVALID_RECHECK_ID",
    API_KEY_USER_EXISTS = "API_KEY_USER_EXISTS",
    USER_ID_NOT_FOUND = "USER_ID_NOT_FOUND",
    CRITERIA_NOT_FOUND = "CRITERIA_NOT_FOUND",
    ADDITIONAL_CRITERIA_NOT_FOUND = "ADDITIONAL_CRITERIA_NOT_FOUND",
    CRITERIA_VALUE_INVALID = "CRITERIA_VALUE_INVALID"
}

export enum SectionType {
    REPORT = "REPORT",
    NON_WEB_DOC = "NON_WEB_DOC"
}

export enum SurveyType {
    SIMPLIFIED = "SIMPLIFIED",
    DETAILED = "DETAILED"
}

export enum ReportStatusType {
    IN_PROGRESS = "IN_PROGRESS",
    DISPATCHED = "DISPATCHED",
    COMPLETED = "COMPLETED"
}

export enum AdministrationLayer {
    NATIONAL = "NATIONAL",
    REGIONAL = "REGIONAL",
    LOCAL = "LOCAL",
    OTHERS = "OTHERS"
}

export enum SystemDetailType {
    OS_WINDOWS_7 = "OS_WINDOWS_7",
    OS_WINDOWS_10 = "OS_WINDOWS_10",
    OS_WINDOWS_11 = "OS_WINDOWS_11",
    OS_LINUX = "OS_LINUX",
    OS_MAC_OS = "OS_MAC_OS",
    OS_IOS = "OS_IOS",
    OS_ANDROID = "OS_ANDROID",
    BROWSER_MICROSOFT_EDGE = "BROWSER_MICROSOFT_EDGE",
    BROWSER_FIREFOX = "BROWSER_FIREFOX",
    BROWSER_CHROME = "BROWSER_CHROME",
    BROWSER_SELENIUM = "BROWSER_SELENIUM",
    BROWSER_SAFARI = "BROWSER_SAFARI",
    ASSIST_NVDA = "ASSIST_NVDA",
    ASSIST_JAWS = "ASSIST_JAWS",
    ASSIST_ZOOMTEXT = "ASSIST_ZOOMTEXT",
    ASSIST_VOICEOVER = "ASSIST_VOICEOVER",
    ASSIST_TALKBACK = "ASSIST_TALKBACK"
}

export enum PublicServiceType {
    SOCIAL_PROTECTION = "SOCIAL_PROTECTION",
    HEALTHCARE = "HEALTHCARE",
    TRAFFIC = "TRAFFIC",
    EDUCATION = "EDUCATION",
    EMPLOYMENT_AND_TAXES = "EMPLOYMENT_AND_TAXES",
    ENVIRONMENTAL_PROTECTION = "ENVIRONMENTAL_PROTECTION",
    LEISURE_AND_CULTURE = "LEISURE_AND_CULTURE",
    HOUSING_AND_COMMUNAL_FACILITIES = "HOUSING_AND_COMMUNAL_FACILITIES",
    PUBLIC_ORDER_AND_SECURITY = "PUBLIC_ORDER_AND_SECURITY",
    MISCELLANEOUS = "MISCELLANEOUS"
}

export enum SearchField {
    bfitId = "bfitId",
    inspectionAuthority = "inspectionAuthority",
    applicationType = "applicationType",
    surveyType = "surveyType",
    artifactName = "artifactName",
    dateOfReport = "dateOfReport",
    status = "status",
    minRecommendationValid = "minRecommendationValid",
    editor = "editor",
    administrationLayer = "administrationLayer"
}

export enum Language {
    de = "de",
    en = "en"
}